// RECORD API
import Request from '../base'
export default {
  saveComment (options) {
    return Request.post('/ebermain/mainapi/record/comment/save', options)
  },
  deleteComment (options) {
    return Request.post('/ebermain/mainapi/record/comment/delete', options)
  },
  loadComment (options) {
    return Request.post('/ebermain/mainapi/record/comment/load', options)
  },
  listComment (options) {
    return Request.post('/ebermain/mainapi/record/comment/list', options)
  },
  findComment (pagination, options) {
    var ps = {}
    if (pagination) {
      ps.sort = pagination.sort || 'time'
      ps.order = pagination.order || 'ASC'
      ps.pageOffset = pagination.current || 1
      ps.pageSize = pagination.size || 10
    }
    for (var k in options) {
      if (options[k]) {
        ps[k] = options[k]
      }
    }
    return Request.post('/ebermain/mainapi/record/comment/find', ps)
  }
}
